import { useQuery } from "@tanstack/react-query";
import {  Project } from "../../../types/project";
import { ApiError } from "../../../types/apiError";
import { getProjectById } from "../api";

export const useProjectQuery = (projectUuid?: string) =>
  useQuery<Project, ApiError>({
    queryKey: ["project", projectUuid],
    queryFn: () => {
      if (!projectUuid) {
        throw new Error("Missing appUserUuid");
      }
      return getProjectById(projectUuid);
    },
    enabled: Boolean(projectUuid), 
    staleTime: 1000 * 60 * 5, 
  });

  